import { getMetaValue } from "helpers"

function assignMemberfulConfig() {
  const config = getMetaValue("memberful-config")
  if (!config) return

  window.memberful = window.memberful || {}
  window.memberful.config = window.memberful.config || {}
  Object.assign(window.memberful.config, JSON.parse(config))
}

export function loadMemberfulConfig() {
  assignMemberfulConfig()
  document.addEventListener("turbo:load", assignMemberfulConfig)
}
